import type React from 'react'

import { forwardRef } from 'react'
import type { AbstractImageProps } from './types.ts'

export const NativeImage: React.ForwardRefExoticComponent<AbstractImageProps> =
  forwardRef<HTMLImageElement, AbstractImageProps>(({ alt, ...props }, ref) => (
    <img {...props} alt={alt} ref={ref} />
  ))
